"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const proj4defs_1 = require("../logic/proj4defs");
var Orientation;
(function (Orientation) {
    Orientation[Orientation["NONE"] = 0] = "NONE";
    Orientation[Orientation["PORTRAIT"] = 1] = "PORTRAIT";
    Orientation[Orientation["LANDSCAPE"] = 2] = "LANDSCAPE";
})(Orientation = exports.Orientation || (exports.Orientation = {}));
function assertConsistency(v) {
    throw new Error(`Internal inconsistency. Unacounted value: ${JSON.stringify(v)}`);
}
function keepAspectRatio(start, end, ratio, orientation) {
    const width = Math.abs(start[0] - end[0]);
    const height = Math.abs(start[1] - end[1]);
    switch (orientation) {
        case Orientation.PORTRAIT:
            return [end[0], start[1] - width / ratio];
        case Orientation.LANDSCAPE:
            return [start[0] + height / ratio, end[1]];
        case Orientation.NONE:
            return end;
    }
    assertConsistency(orientation);
}
const ISO216PaperRatio = 1 / Math.sqrt(2);
function getUTMAreaBox({ area, getAspectRatioOrientation, polygon }) {
    const zone = proj4defs_1.utmZoneWM(area.topLeft);
    const [topLeftUTM, bottomRightUTM] = [area.topLeft, area.bottomRight].map(c => proj4defs_1.webmercator2utm(zone, c));
    const bottomRightUTMWithAspect = keepAspectRatio(topLeftUTM, bottomRightUTM, ISO216PaperRatio, getAspectRatioOrientation());
    const p = polygon || new ol.geom.Polygon(null);
    p.setCoordinates([[
            proj4defs_1.utm2webmercator(zone, topLeftUTM),
            proj4defs_1.utm2webmercator(zone, [bottomRightUTMWithAspect[0], topLeftUTM[1]]),
            proj4defs_1.utm2webmercator(zone, bottomRightUTMWithAspect),
            proj4defs_1.utm2webmercator(zone, [topLeftUTM[0], bottomRightUTMWithAspect[1]]),
            proj4defs_1.utm2webmercator(zone, topLeftUTM)
        ]]);
    return p;
}
exports.getUTMAreaBox = getUTMAreaBox;



//////////////////
// WEBPACK FOOTER
// ./src/map/utmArea.ts
// module id = 287
// module chunks = 0